import { useEffect, useRef, useState } from 'react';
import EditComponent from './MembershipMarketingDetailsEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';
import { Button, Popover, Space, Switch } from 'antd';
import dayjs from 'dayjs';
import MembershipRechargePlansApplicablesMerchants from './MembershipRechargePlansApplicablesMerchants';
import fetchApi from '../../../utils/api/fetchApi';
import AntdNotification from '../../../utils/extend/AntdNotification';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const [membershipRechargePlansId, setMembershipRechargePlansId] = useState<any>();
    const [modalVisibleMembershipRechargePlansApplicablesMerchants,
        setModalVisibleMembershipRechargePlansApplicablesMerchants] = useState<any>();
    /** 当前打开的 Popover ID */
    const [activePopoverId, setActivePopoverId] = useState<string | null>(null);

    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [InitData, setInitData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setInitData(() => ref.current.initData);
        }
    }, []);

    //表头
    const columnsHead = [
        {
            title: '会员',
            dataIndex: 'membershipInfo',
            render: (val: any) => val?.membershipName
        },
        {
            title: '方案',
            dataIndex: 'membershipMarketingPlans',
            render: (val: any) => val?.planName
        },
        {
            title: '类型',
            dataIndex: 'membershipGiftType',
            render: (val: any) => val?.name
        },
        {
            title: '成功日期',
            dataIndex: 'successfulDate',
            render: (val: any) => dayjs(val).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '成功',
            dataIndex: 'isGiftSuccessful',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '',
            dataIndex: 'id',
            render: (id: string, record: any) => {
                if (record.isGiftSuccessful === true && record.isUse === true && (record.isPointsVoid === false || record.isGiftCardVoid === false)) {
                    return (
                        <Popover
                            title="是否撤销？"
                            trigger="click"
                            content={(<Space>
                                <Button onClick={() => setActivePopoverId(null)}>否</Button>
                                <Button type='primary' onClick={() => {
                                    fetchApi.PUT(defaultService,
                                        {
                                            apiId: 'membershipMarketingDetails',
                                            apiExtend: 'giftVoid',
                                            apiData: {
                                                id
                                            }
                                        }).then(res => {
                                            if (res?.success === true) {
                                                AntdNotification('success', '执行撤销成功');
                                                InitData();
                                            } else {
                                                AntdNotification('error', res?.message);
                                            }
                                        });
                                    setActivePopoverId(null);
                                }}>是</Button>
                            </Space>)}
                            open={activePopoverId === id}
                            onOpenChange={(visible) => {
                                setActivePopoverId(visible ? id : null);
                            }}
                        >
                            <Button type="default">撤销</Button>
                        </Popover>
                    )
                }
            }
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '营销详情',
        apiId: 'membershipMarketingDetails',
        columns,
        showStates: true,
        EditComponent,
        serviceId: 'business'
    };

    return (
        <>
            {modalVisibleMembershipRechargePlansApplicablesMerchants ?
                (<MembershipRechargePlansApplicablesMerchants
                    closeModal={() => setModalVisibleMembershipRechargePlansApplicablesMerchants(false)}
                    data={membershipRechargePlansId} />)
                : null}
            <WebUniversal props={extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;
